import React, { useState } from 'react';
import { List, Datagrid, TextField, FunctionField, SimpleList } from 'react-admin';
import { useMediaQuery, makeStyles, FormControl, InputLabel, Select, MenuItem, Paper, Typography, Tooltip } from '@material-ui/core';
import { customTheme } from "./customTheme";
import ScrollableTable from './components/ScrollableTable';
// import moment from 'moment'
import { useLocation } from 'react-router-dom';
import CustomPagination from './components/CustomPagination';
import ParkingSearchSelector from './components/ParkingSearchSelector';
import CustomSearch from './components/CustomSearch';
import { vehicleSvgs, paymentModeColors } from "./sharedData";
import ImageGalleryDialogV2 from './components/ImageGalleryDialogV2';
import queryString from 'query-string';
import notify from './components/CustomUseNotify';
import config from "./config.json";
import { saveTokens } from './utils/saveTokens';
import { stringify } from 'query-string';
import Skeleton from '@material-ui/lab/Skeleton';
import CustomFilter from './components/CustomFilter';
import BrokenImageOutlinedIcon from '@material-ui/icons/BrokenImageOutlined';
import moment from 'moment';
import sideArrow from './images/white_side_arrow.png'

const useStyles = makeStyles({
    list: {
        marginBottom: 0,
    },
    loaderContainer: {
        display: "flex",
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
    chipCell: {
        textAlign: "center",
        padding: customTheme.spacing(1, 2),
        display: "inline-block",
        borderRadius: 50,
        minWidth: 100,
    },
    title: {
        fontSize: 14,
        color: customTheme.palette.secondary.main,
    },
    mainValue: {
        fontSize: 22,
        color: customTheme.palette.grey[900],
    },
    summaryBox: {
        padding: customTheme.spacing(3, 3),
    },
    twoColumnGrid: {
        padding: customTheme.spacing(1, 0, 2),
        display: "grid",
    },
    flexContainer: {
        display: 'flex',
        alignItems: "center",
    },
    summaryVehicleIcon: {
        width: 18,
        height: 18,
    },
    summaryBoxLabel1: {
        fontSize: "0.74em",
        color: customTheme.palette.grey[500],
        margin: customTheme.spacing(0, 2, 0, 1),
    },
    summaryBoxLabel2: {
        fontSize: 14,
        color: customTheme.palette.secondary.main,
    },
    paymentSummaryBoxLabel1: {
        fontSize: "0.74em",
        color: customTheme.palette.grey[500],
    },
    summaryBoxValue1: {
        fontSize: 13,
        color: customTheme.palette.grey[900],
    },
    tooltip: {
        fontSize: 13
    }
});

const renderVehicleType = (row) => (
    row.vehicle_type ?
        <div style={{ display: 'flex', alignItems: "center" }}>
            <img src={vehicleSvgs[row.vehicle_type]} style={{ width: 25, height: 25, marginRight: 8, overflow: "visible" }} alt={row.vehicle_type_label} />
            {/* row.vehicle_type_label */}
        </div>
        :
        null
);

const SUMMARY_COLUMNS = {
    "Type": true,
    "Vehicle Number": true,
    "Amount": true,
    "Duration": true,
    "Entry": true,
    "Gate": true,
    "Time": true,
    "Payment": true,
    "Device": true,
    "Remarks": false,
    "Visit Reason": false,
    "Visit Destination": false,
    "Helmet Cost": false
};

function vehicleSummaryMaskHandler(value, type = "Count") {
    if (typeof value === "number") {
        value = value.toFixed(2);
        let trimCount = 0;
        if (value.charAt(value.length - 1) === "0") {
            trimCount = 1;
            if (value.charAt(value.length - 2) === "0") {
                trimCount = 3;
            }
        }
        value = value.substring(0, value.length - trimCount);
    }
    if (sessionStorage.getItem("vehicle_summary_mask") === "1") {
        let valueString = value.toString();
        if (valueString.includes(".")) {
            let [integerPart, decimalPart] = valueString.split(".");
            let integerPartLength = integerPart.length;
            let stars = "*".repeat(Math.max(0, integerPartLength - 2));
            let convertedIntegerPart = integerPart.slice(-2);
            if (integerPart.length === 1) {
                convertedIntegerPart = "*" + integerPart;
            }
            return stars + convertedIntegerPart + "." + decimalPart;
        } else if (valueString.length <= 2) {
            return "*".repeat(valueString.length);
        } else {
            return valueString.slice(0, -2) + "**";
        }
    } else return value
}

const CATEGORIESNEW = {
    PAID: { label: "Paid", style: { color: "#18CC69", backgroundColor: "#18CC6919", borderRadius: 2 } },
    FOC: { label: "FOC", style: { color: "#5E8DD3", backgroundColor: "#5E8DD319", borderRadius: 2 } },
    IDF: { label: "Drop Off", style: { color: "#F7685B", backgroundColor: "#F7685B19", borderRadius: 2 } },
    UNPAID: { label: "Unpaid", style: { color: "#18CC69", backgroundColor: "#18CC6919", borderRadius: 2 } }
};

const FASTAG_STATUS = {
    "ACTIVE": { color: "#18CC69", backgroundColor: "#18CC6919" },
    "HOTLIST": { color: "#F7685B", backgroundColor: "#F7685B19" },
    "EXEMPT": { color: "#F7685B", backgroundColor: "#F7685B19" },
    "CLOSED": { color: "#F7685B", backgroundColor: "#F7685B19" },
    "BLACKLIST": { color: "#F7685B", backgroundColor: "#F7685B19" },
    "INVALID CARRIAGE": { color: "#F7685B", backgroundColor: "#F7685B19" },
    "LOW BALANCE": { color: "#F7685B", backgroundColor: "#F7685B19" },
    "DEFAULT": { color: "#F7685B", backgroundColor: "#F7685B19" },
};

export const CurrentlyParked = (props) => {
    const classes = useStyles()
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const location = useLocation();
    const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");
    let prevSearch = sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : ""
    const [currentParking, setCurrentParking] = useState(prevSearch.currentParking ? prevSearch.currentParking : {});
    const [summaryData, setSummaryData] = useState({})
    const [loadingSummary, setLoadingSummary] = useState(false);
    const zoneIds = currentParking.zone_ids ? currentParking.zone_ids.split(",") : null;
    const zoneLabels = currentParking.zones ? currentParking.zones.split(";") : null;
    const finalZones = zoneIds && zoneLabels ? zoneIds.map((id, index) => (
        { id, name: zoneLabels[index] }
    )) : null;
    if (finalZones)
        finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));

    const [search, setSearch] = useState(prevSearch.inputSearch)
    let searchTypeState = ["Vehicle Number"]
    const [searchTypes, setSearchTypes] = useState(prevSearch.type ? prevSearch.type : "Vehicle Number");
    const [displayColumns, setDisplayColumns] = useState(localStorage.getItem("currentlyParkedColumns") ? JSON.parse(localStorage.getItem("currentlyParkedColumns")) : SUMMARY_COLUMNS);
    const [isSurveillanceExit] = useState(false);
    const [filterListValue, setFilterListValue] = useState(null);
    const [showTimeTillSeconds] = useState(sessionStorage.getItem("show_time_till_seconds") === "1");
    const [use24HourFormat] = useState(sessionStorage.getItem("use_24_hour_format") === "1");
    const filter = { search: { value: search ? search : "", type: searchTypes ? searchTypes : "" }, access_key: currentParking.id, parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined };
    
    const filterTypesInitState = [
        {
            filterType: "Display Columns",
            dataList: [],
            listType: "CheckboxStatic",
            caseType: "CheckboxTypeStatic",
            showFilter: true,
            filterFormat: "Checkbox"
        }
    ];

    const timeFormat = (type, time, timeComparison, style = false) => {
        let addSeconds = showTimeTillSeconds ? ":ss" : "";
        let format = use24HourFormat ? `HH:mm${addSeconds}` : `hh:mm${addSeconds} A`
        return type === "ENTRY" ? <div className={style ? "tableTimeFormatStyle" : ""}>
            <div className={'logsTableDataColor1 fontWeightBold'}>{moment(time).format(format)}</div>
            <div className={'logsTableDataColor2 fontWeightMedium'}>{moment(time).format("DD/MM/YYYY")}</div>
        </div> :
            <div className={style ? "tableTimeFormatStyle" : ""}>
                <div className={'logsTableDataColor1 fontWeightBold'}>{moment(time).format(format)}</div>
                <div className={'logsTableDataColor2 fontWeightMedium'}>{moment(time).format("DD/MM/YYYY")}</div>
            </div>
    }


    const onParkingChange = (parking) => {
        setCurrentParking({ ...parking, allZones: true });
    };

    const onZoneChange = (event) => {
        setCurrentParking({
            ...currentParking,
            id: event.target.value,
            name: zoneLabels[zoneIds.findIndex(id => id === event.target.value)],
            allZones: event.target.value === "All"
        });
    };

    const fetchSummary = () => {
        setLoadingSummary(true);
        var params = {
            access_key_id: currentParking.id ? currentParking.id : undefined,
            parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined,
            access_key: currentParking.access_key ? currentParking.access_key : undefined,
        }

        fetch(`${config.HOST_NAME}/crm/v3/currentlyParkedSummary?${stringify(params)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`
            },
        })
            .then(response => {
                saveTokens(response);
                return response.json();
            })
            .then(json => {
                if (json.success) setSummaryData(json.data);
                else notify(json.message, "warning");
            })
            .catch((e) => {
                console.log(e);
                notify("Something went wrong", "warning");
            })
            .finally(() => {
                setLoadingSummary(false);
            });
    };

    React.useEffect(() => {
        if ((currentParking && currentParking.id) || !showFilter) fetchSummary()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentParking, showFilter])

    React.useEffect(() => {
        const queryParams = queryString.parse(props.location.search);
        if (queryParams.parking)
            setCurrentParking(JSON.parse(queryParams.parking));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props]);


    return (
        <div>
            <div className={classes.parkingSelectorContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0, margin: 0 }}>
                {showFilter &&
                    <ParkingSearchSelector
                        value={currentParking}
                        onChange={onParkingChange}
                        clearable={true}
                        pathName={location.pathname}
                    />
                }

                {currentParking.zone_ids && currentParking.zone_ids.includes(',') &&
                    <FormControl variant="outlined" style={{ marginTop: isSmallDevice ? 0 : 10 }}>
                        <InputLabel>Zone Name</InputLabel>
                        <Select
                            value={currentParking.allZones ? "All" : currentParking.id}
                            onChange={onZoneChange}
                            label="Zone Name"
                            variant="outlined"
                        >
                            <MenuItem value="All">All</MenuItem>
                            {finalZones.map((zone, index) => (
                                <MenuItem key={index} value={zone.id}>{zone.name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                }
            </div>
            {(!showFilter || (currentParking && currentParking.id)) && <div className='customStyleForDataSearchDiv'>
                <CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={searchTypeState} pathName={location.pathname} />
                <CustomFilter
                    filterTypesInitState={filterTypesInitState}
                    filterListValue={filterListValue}
                    setFilterListValue={setFilterListValue}
                    defaultColumns={SUMMARY_COLUMNS}
                    displayColumns={displayColumns}
                    setDisplayColumns={setDisplayColumns}
                    storageKey="currentlyParkedColumns"
                />
            </div>}

            {(!showFilter || (currentParking && currentParking.id)) && <div className="vehicleSummaryContainer" style={{ marginTop: 15 }}>
                <CurrentlyParkedSummaryCard
                    title="Currently Parked"
                    value={summaryData && summaryData.totalCurrentVehicles}
                    vehicleTypes={summaryData && summaryData.vehicleTypes}
                    loading={loadingSummary}
                />
            </div>
            }

            <List {...props}
                style={{ marginTop: 20 }}
                empty={false}
                filter={filter}
                title="Currently Parked"
                bulkActionButtons={false}
                exporter={false}
                actions={false}
                pagination={<CustomPagination />} >

                {isSmallDevice ?
                    <SimpleList
                        primaryText={record => record && record.license_number}
                        secondaryText={record => (<div>
                            {record.entry_time && <div><span style={{ color: "#5a5a5a" }}>Entry Time: </span>{record.entry_time}</div>}
                            {record.entry_user_id && <div><span style={{ color: "#5a5a5a" }}>Entry User ID: </span>{record.entry_user_id}</div>}
                            {record.remarks && <div><span style={{ color: "#5a5a5a" }}>Remarks: </span>{record.remarks}</div>}
                            {record.violation && <div><span style={{ color: "#5a5a5a" }}>Violation: </span>{record.violation}</div>}
                            {record.visit_reason && <div><span style={{ color: "#5a5a5a" }}>Visit Reason: </span>{record.visit_reason}</div>}
                            {record.visit_destination && <div><span style={{ color: "#5a5a5a" }}>Visit Destination: </span>{record.visit_destination}</div>}
                            {record.helemt_cost && <div><span style={{ color: "#5a5a5a" }}>Helemt Cost: </span>{record.helemt_cost}</div>}

                        </div>)}
                        onContextMenu={event => event.preventDefault()}
                        linkType={false}
                        rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                    />
                    :
                    <Datagrid component={ScrollableTable}>
                        {displayColumns["Type"] && <FunctionField label="Vehicle Type" render={renderVehicleType} />}
                        {displayColumns["Vehicle Number"] &&
                            <FunctionField source="license_number" label="Vehicle Number"
                                render={(record) => <span className='fontWeightSemiBold secondaryColor'>{record.license_number}</span>}
                            />}

                        {displayColumns["Amount"] &&
                            <FunctionField source="license_number" label="Amount"
                                render={(record) =>
                                    <div style={{ textAlign: "center" }}>
                                        <div className='fontWeightBold secondaryColor' style={{ fontSize: 12 }}>
                                            {record.total_amount != null && record.total_amount > 0 ? `₹ ${vehicleSummaryMaskHandler(parseFloat(parseFloat(record.total_amount.toFixed(2))), "Amount")}` : (record.amount_at_entry && record.amount_at_entry > 0 ? `₹ ${vehicleSummaryMaskHandler(parseFloat(parseFloat(record.amount_at_entry).toFixed(2)), "Amount")}` : record.category === "IDF" ? `₹ 0` : "-")}
                                        </div>
                                        <div>
                                            {(currentParking.show_violation_details === 1 && record.violation) || isSurveillanceExit ?
                                                <div className="fontWeightBold" style={{ backgroundColor: "#F7685B", color: "#FFFFFF", fontSize: 10, borderRadius: 2, padding: "1px 0px" }}>
                                                    Violation
                                                </div>
                                                :
                                                record.category ? <div className="fontWeightBold" style={{ display: "flex", justifyContent: "center", alignItems: "center", ...CATEGORIESNEW[record.category].style, fontSize: 10, padding: "1px 0px" }}>
                                                    <div style={{ flex: 1 }}>{record.category === "IDF" && record.is_commercial === 1 ? "Drop off-C" : record.category === "IDF" && record.is_commercial === 0 ? "Drop off-P" : record.category === "IDF" && (record.is_commercial === null || record.is_commercial === "") ? "Drop off-M" : CATEGORIESNEW[record.category].label}</div>
                                                    {CATEGORIESNEW[record.category].label === "FOC" &&
                                                        <Tooltip arrow title={record.remarks ? record.remarks : "No Remarks"} classes={{ tooltip: { fontSize: 10 } }}>
                                                            <div style={{ alignSelf: "flex-end", backgroundColor: "#5E8DD3", padding: "0px 5px", borderRadius: 2 }}>
                                                                <img src={sideArrow} alt='arrow' />
                                                            </div>
                                                        </Tooltip>}
                                                </div> : <div className="fontWeightBold" style={{ color: "#334D6E", backgroundColor: "#EBEFF2", fontSize: 10, borderRadius: 2 }}>
                                                    -
                                                </div>
                                            }
                                        </div>
                                    </div>
                                }
                            />}

                        {displayColumns["Duration"] &&
                            <FunctionField source="license_number" label="Duration"
                                render={(record) => record.exit_time && record.exit_user_id !== "CLEARED" ? moment(record.exit_time).to(record.entry_time, true) : "-"}
                            />}


                        {displayColumns["Entry"] &&
                            <FunctionField source="license_number" label="Entry"
                                render={(record) => <div>
                                    {(typeof record.vehicle_entry_image_url === "string" && record.vehicle_entry_image_url !== "") ? <ImageGalleryDialogV2 thumbnail={true} thumbnailUrl={record.vehicle_entry_image_url_thumbnail} record={record} getImages={(record) => {
                                        let parkingImage = record.vehicle_entry_image_url;
                                        if (record.parking_images) {
                                            const imgs = JSON.parse(record.parking_images);
                                            return [...imgs]
                                        } else {
                                            return [parkingImage]
                                        }
                                    }} />
                                        : <div className='tableDataImg logsTableDataColor1' style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <BrokenImageOutlinedIcon />
                                        </div>
                                    }
                                </div>}
                            />}

                        {displayColumns["Gate"] &&
                            <FunctionField source="license_number" label="Gate"
                                render={(record) => <div>
                                    <div className='logsTableDataColor1'>{record.entry_user_id}</div>
                                    {record.mode_of_payment_at_entry ? <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
                                        <div className="logsTableDataColor2" style={{ marginRight: 5 }}>{record.mode_of_payment_at_entry === "FASTag" || record.mode_of_payment_at_entry === "ANPR" ? record.mode_of_payment_at_entry : "POS"}</div>
                                        {record.mode_of_payment_at_entry === "FASTag" &&
                                            <Tooltip arrow title={record.fastag_status_at_entry} classes={{ tooltip: classes.tooltip }}><div style={{ display: 'flex', alignItems: "center", justifyContent: "center", height: 15, width: 15, borderRadius: 20, marginRight: 8, backgroundColor: FASTAG_STATUS[record.fastag_status_at_entry] ? FASTAG_STATUS[record.fastag_status_at_entry].backgroundColor : FASTAG_STATUS["DEFAULT"].backgroundColor }}>
                                                <div className={classes.statusCircle} style={{ backgroundColor: FASTAG_STATUS[record.fastag_status_at_entry] ? FASTAG_STATUS[record.fastag_status_at_entry].color : FASTAG_STATUS["DEFAULT"].color }} />
                                            </div></Tooltip>}
                                    </div> : <div>-</div>}
                                </div>}
                            />}

                        {displayColumns["Time"] &&
                            <FunctionField source="license_number" label="Time"
                                render={(record) => record.entry_time ? timeFormat("ENTRY", record.entry_time, moment()) : <div>-</div>}
                            />}

                        {displayColumns["Payment"] &&
                            <FunctionField source="license_number" label="Payment"
                                render={(record) => <div style={{ textAlign: "center" }}>
                                <div className='fontWeightBold secondaryColor' style={{ fontSize: 12 }}>
                                    {record.amount_at_entry > 0 ? `₹ ${vehicleSummaryMaskHandler(parseFloat(parseFloat(record.amount_at_entry)), "Amount")}` : "-"}
                                </div>
                                {record.amount_at_entry > 0 && record.mode_of_payment_at_entry ? <div className="fontWeightBold" style={paymentModeColors[record.mode_of_payment_at_entry] ? { color: paymentModeColors[record.mode_of_payment_at_entry], backgroundColor: (paymentModeColors[record.mode_of_payment_at_entry] + "19"), fontSize: 10, borderRadius: 2 } : { color: "#555555", backgroundColor: "#55555519", fontSize: 10, borderRadius: 2 }}>
                                    {record.mode_of_payment_at_entry}
                                </div> : <div className="fontWeightBold" style={{ color: "#334D6E", backgroundColor: "#EBEFF2", fontSize: 10, borderRadius: 2 }}>
                                    -
                                </div>}
                            </div>}
                            />}

                        {displayColumns["Device"] &&
                            <FunctionField source="license_number" label="Device"
                                render={(record) => <div className='logsTableDataColor1'>{record && record.entry_device_id && record.entry_device_id !== "CLEARED" ? record.entry_device_id : "-"}</div>}
                            />}
                        {displayColumns["Remarks"] && <TextField source="remarks" label="Remarks" />}
                        {displayColumns["Violation"] && <TextField source="violation" label="Violation" />}
                        {displayColumns["Visit Reason"] && <TextField source="visit_reason" label="Visit Reason" />}
                        {displayColumns["Visit Destination"] && <TextField source="visit_destination" label="Visit Destination" />}
                        {displayColumns["Helmet Cost"] && <TextField source="helemt_cost" label="Helmet Cost" />}
                    </Datagrid>
                }
            </List>
        </div>
    )
};


function CurrentlyParkedSummaryCard({ title, value, vehicleTypes, loading }) {
    const classes = useStyles();
    return <>
        <Paper style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', boxShadow: "0px 4px 15px #0000001a", padding: "14px 20px" }}>
            <div style={{ flex: 1 }}>
                <div style={{ marginBottom: 10 }}>
                    <Typography className={classes.title}>{title}</Typography>
                    {!loading && value ? <Typography className={classes.mainValue}>{value}</Typography>
                        : !loading && !value ? <Typography className={classes.mainValue}>0</Typography>
                            : <Skeleton variant="text" height={36} width="34%" />
                    }
                </div>
                {
                    !loading && vehicleTypes ? Object.keys(vehicleTypes).filter((type) => vehicleTypes[type].hasOwnProperty('count')).map((type, index) => {
                        return <div key={index} className={classes.flexContainer}>
                            <img className={classes.summaryVehicleIcon} src={vehicleSvgs[type]} alt="labels" />
                            <Typography className={classes.summaryBoxLabel1} style={{ marginRight: 16 }}>{vehicleTypes[type].label}:</Typography>
                            <Typography className={classes.summaryBoxValue1}>{vehicleTypes[type].count}</Typography>
                        </div>

                    })
                        : ["50%", "40%", "50%"].map((width, index) => (
                            <Skeleton variant="text" width={width} height={22} key={index} />
                        ))
                }
            </div>
        </Paper>
    </>
}